//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 29/10/2024
// Version : 1
// Description : pantalla para tabla de vehiculos inactivos
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Typography,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import Navbar from "../../Navbar";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import { logEventos } from "../../../services/services";
import { useMediaQuery } from "@mui/material";

function VehiculosInactividad() {
  const [vehiculoInactivo, setVehiculoInactivo] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");

  const [selectedDate, setSelectedDate] = useState(
    dayjs().subtract(1, "month").startOf("month")
  );

  const obtenerVehiculosInactivos = () => {
    const formattedDate = selectedDate.format("YYYY"); // Formatear la fecha seleccionada
    fetch(
      UrlApi + "/checklist_chofer_flota/vehiculosInactivos/" + formattedDate
    )
      .then((data) => data.json())
      .then((data) => setVehiculoInactivo(data));
  };

  useEffect(() => {
    obtenerVehiculosInactivos();
  }, [selectedDate]); // Actualizar los datos cuando se cambie la fecha

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
  };

  //console.log("Vehiculo inactivo", vehiculoInactivo);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const todosLosMeses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  // Función para obtener el nombre del mes y el año a partir de la fecha en formato YYYY-MM
  const obtenerNombreMes = (fecha) => {
    const mes = dayjs(fecha, "YYYY-MM").format("M") - 1; // Extraer el mes (0-11)
    return todosLosMeses[mes];
  };

  const transformarDatosParaBarChart = (data) => {
    // Agrupamos los datos por patente
    const grupos = data.reduce((acc, item) => {
      const { patente, marca, modelo, sucursal, total_dias_inactivos, fecha } =
        item;
      const nombreMes = obtenerNombreMes(fecha);

      if (!acc[patente]) {
        acc[patente] = {
          marca,
          modelo,
          sucursal,
          inactividad: { [nombreMes]: total_dias_inactivos },
        };
      } else {
        acc[patente].inactividad[nombreMes] = total_dias_inactivos;
      }
      return acc;
    }, {});

    const dataset = Object.keys(grupos).map((patente) => ({
      patente,
      marca: grupos[patente].marca,
      modelo: grupos[patente].modelo,
      sucursal: grupos[patente].sucursal,
      ...grupos[patente].inactividad,
    }));

    return { dataset, meses: todosLosMeses };
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // Filtrar los datos basados en la búsqueda
  const filteredVehiculos = vehiculoInactivo.filter(
    (vehiculo) =>
      (vehiculo.patente?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.marca?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.modelo?.toLowerCase() || "").includes(searchQuery) ||
      (vehiculo.sucursal?.toLowerCase() || "").includes(searchQuery)
  );

  const { dataset, meses } = transformarDatosParaBarChart(filteredVehiculos);

  // const HeaderCell = styled(TableCell)({
  //   marginTop: "2px",
  //   fontSize: 16,
  //   color: "white",
  //   fontWeight: "normal",
  //   backgroundColor: "#2471A3",
  //  // borderColor: "black",
  //   padding: "6.3px",
  // });

  // *********************************************************** Tabla ********************************************************************** //
  useEffect(() => {
    logEventos(
      "acceso al menú Vehiculos Inactividad",
      "Evaluacion Comerciales",
      "Vehiculos Inactividad",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={1}
        borderRadius={0}
        color="white"
        textAlign="center"
      >
        <Grid container>
          <Grid
            item
            xs={12}
            md={4}
            textAlign={isMobile ? "center" : "left"}
            marginBottom={1}
          >
            <Typography variant="h4" component="div">
              Vehiculos Inactivos {selectedDate.year()}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          container
          spacing={2}
          justifyContent={isMobile ? "center" : "center"}
        >
          <Grid item xs={12} sm={6} md="auto">
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DatePicker
                views={["year"]}
                value={selectedDate}
                onChange={handleDateChange}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      "& .MuiInputBase-root": {
                        color: "black", // Color del texto
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white", // Color del borde
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black", // Color del borde al pasar el mouse
                      },
                      "& .MuiInputLabel-root": {
                        color: "white", // Color del label
                      },
                      backgroundColor: "white",
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          {/* TextField para búsqueda */}
          <Grid item xs={12} sm={6} md="auto">
            <TextField
              variant="outlined"
              size="small"
              placeholder="Buscar ..."
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{
                width: "250px",
                backgroundColor: "white",
                "& .MuiInputLabel-root": {
                  color: "black",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "black",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <TableContainer>
        <Box
          sx={{
            maxHeight: "75vh",
            overflow: "auto",
            marginTop: 3,
            maxWidth: "100%",
            mx: "auto",
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: 12, sm: 12, md: 14 },
                    padding: "2px 4px",
                    width: "auto",
                    backgroundColor: "#2B76A6",
                    borderRight: "1px solid black",
                  }}
                >
                  <b>Patente</b>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: 12, sm: 12, md: 14 },
                    padding: "2px 4px",
                    width: "auto",
                    backgroundColor: "#2B76A6",
                    borderRight: "1px solid black",
                  }}
                >
                  <b>Marca</b>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: 12, sm: 12, md: 14 },
                    padding: "2px 4px",
                    width: "auto",
                    backgroundColor: "#2B76A6",
                    borderRight: "1px solid black",
                  }}
                >
                  <b>Modelo</b>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: { xs: 12, sm: 12, md: 14 },
                    padding: "2px 4px",
                    width: "auto",
                    backgroundColor: "#2B76A6",
                    borderRight: "1px solid black",
                  }}
                >
                  <b>Sucursal</b>
                </TableCell>

                {meses.map((mes, index) => (
                  <TableCell
                    key={index}
                    align="center"
                    style={{
                      backgroundColor: "#2B76A6",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: { xs: 12, sm: 12, md: 14 },
                      padding: "2px 4px",
                      width: "auto",
                      borderRight: "1px solid black",
                    }}
                  >
                    {mes}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {dataset.map((vehiculo, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#DADADA", // Alterna colores por línea
                    "& td": {
                      padding: "3px 4px",
                      fontSize: 12,
                      width: "auto",
                      borderRight: "1px solid black",
                    },
                  }}
                >
                  <TableCell align="left">{vehiculo.patente}</TableCell>
                  <TableCell align="left">{vehiculo.marca}</TableCell>
                  <TableCell align="left">{vehiculo.modelo}</TableCell>
                  <TableCell align="left">{vehiculo.sucursal}</TableCell>
                  {meses.map((mes, mesIndex) => (
                    <TableCell key={mesIndex} align="right">
                      {vehiculo[mes] || 0}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </TableContainer>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default VehiculosInactividad;
